// Same locales as in InternationalizationService.js
import "moment/locale/da.js";
import "moment/locale/de.js";
import "moment/locale/en-gb.js";
import "moment/locale/es.js";
import "moment/locale/fi.js";
import "moment/locale/nb.js";
import "moment/locale/nl.js";
import "moment/locale/se.js";
import "moment/locale/sv.js";
import moment from "moment";

moment.locale("en");

export { default } from "moment";
